import React, { useState, useEffect } from 'react'
import { PencilIcon, CheckIcon } from '@heroicons/react/outline';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from './../../components/Layout/Layout';
import InvestmentServices from './../../services/InvestmentServices';
import { FormatMoney, FormatDollar } from './../../utils/formatMoney';
import fire from './../../utils/Toastr';



export default function Rates() {
    const data = {
        id: 0,
        rate: 0,
        minimumAmount: 0,
        maximumAmount: 0,
        tenure: ""
    }
    const [rate, setRate] = useState([])
    const [rateVale, setRateValue] = useState("")
    const [search, setSearch] = useState("")
    const [newRate, setNew] = useState(0)
    const [formValue, setFormValues] = useState(data)

    const update = async (rate) => {
        const data = {
            id: rate,
            rate: newRate,
            minimumAmount: 0,
            maximumAmount: 0,
            tenure: ""
        }
        const resp = await InvestmentServices.updateInvestment(data);
        if (resp) {
            setTimeout(() => {
                fire("success", resp.message);
            }, 2000);
        }
        window.location.reload();
    }
    const handleRate = async (e) => {
        setNew(e)
        setFormValues({ ...formValue, rate: newRate })
    }
    const edit = async (rate) => {
        setRateValue(rate)
    }
    const list = async () => {
        const resp = await InvestmentServices.listRates(search);
        setRate([...resp.data])
    }

    useEffect(() => {
        list();
    }, [])
    return (<>
        <Layout title="Rates Guide" pageTag={"investment"} current={'/investments/rates'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <p>Investment Rate Guide – Fixed Deposit (NGN)​</p>
                                </div>

                            </div>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="min-w-[14rem] pl-3 py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                            Mininum Amount( Naira)
                                                        </th>
                                                        <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                            Maximum Amount(Naira)
                                                        </th>
                                                        <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                            Rate
                                                        </th>
                                                        <th scope="col" className="min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Tenure
                                                        </th>

                                                        <th></th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {rate.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            {person.investmentTypeName === "Premium Fixed Deposit Naira" && <>
                                                                <td className="pl-4 whitespace-nowrap px-3 py-4 text-sm text-gray-900"> {FormatMoney(person.minimumAmount)}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{FormatMoney(person.maximumAmount)}</td>
                                                                {rateVale !== person.id ?
                                                                    <>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.rate}</td>
                                                                    </> :
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                        <input
                                                                            type="text"
                                                                            name="rate"
                                                                            placeholder={person.rate}
                                                                            onChange={(e) => handleRate(e.target.value)}
                                                                        />
                                                                    </td>
                                                                }
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.tenure}</td>
                                                                {rateVale !== person.id ?
                                                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                        <button onClick={() => edit(person.id)}>
                                                                            <PencilIcon className="w-4" />
                                                                        </button>
                                                                    </td> :
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                        <button
                                                                            onClick={() => update(person.id)} >
                                                                            <CheckIcon className='w-8' />
                                                                        </button>
                                                                    </td>
                                                                }
                                                            </>}

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Deposit ussd */}
                        <div className='mt-8'>
                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">
                                        <p>Investment Rate Guide – Fixed Deposit (USD)​</p>
                                    </div>
                                </div>
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" className="min-w-[14rem] pl-3 py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                Mininum  Amount(USD)
                                                            </th>
                                                            <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                Maximum Amount(USD)
                                                            </th>
                                                            <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                Rate
                                                            </th>
                                                            <th scope="col" className="min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                                Tenure
                                                            </th>
                                                            <th></th>
                                                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                                <span className="sr-only">Edit</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-200 bg-white">
                                                        {rate.map((person, i) => (
                                                            <tr key={i} className="bg-gray-50">
                                                                {person.investmentTypeName === "Premium Fixed Deposit Dollar" &&
                                                                    <>
                                                                        <td className="ml-3 whitespace-nowrap px-3 py-4 text-sm text-gray-900">{FormatDollar(person.minimumAmount)}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.isInfinity === true ? "Infinity" : FormatDollar(person.maximumAmount)} </td>
                                                                        {rateVale !== person.id ?
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.rate}</td> :
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900" >
                                                                                <input
                                                                                    type="text"
                                                                                    name='rate'
                                                                                    placeholder={person.rate}
                                                                                    onChange={(e) => handleRate(e.target.value)}
                                                                                />
                                                                            </td>
                                                                        }
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.tenure}</td>
                                                                        {rateVale !== person.id ?
                                                                            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                                <button value={person.id} onClick={() => edit(person.id)}>
                                                                                    <PencilIcon className="w-4" />
                                                                                </button>
                                                                            </td> :
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                                <button
                                                                                    onClick={() => update(person.id)} >
                                                                                    <CheckIcon className='w-8' />
                                                                                </button>
                                                                            </td>
                                                                        }
                                                                    </>}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* investment rate guide - call deposit(NGN) */}
                        <div className='mt-8'>
                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">
                                        <p>Investment Rate Guide – Call Deposit (NGN)​​</p>
                                    </div>
                                </div>
                                {rate.length === 0 ?  (
                    <div className="mt-8"> No data available for these dates to show. </div>
                  ) : 
                  <>
                  <div className="mt-8 flex flex-col ">
                                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                              <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                  <thead>
                                                      <tr>
                                                          <th scope="col" className="min-w-[14rem] pl-6 py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                              Mininum Amount(Naira)
                                                          </th>
                                                          <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                              Maximum Amount (Naira)
                                                          </th>
                                                          <th scope="col" className="min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                              Rate
                                                          </th>
                                                          <th></th>
                                                          <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                              <span className="sr-only">Edit</span>
                                                          </th>
                                                      </tr>
                                                  </thead>
                                                  <tbody className="divide-y divide-gray-200 bg-white">
                                                      {rate.map((person, i) => (
                                                          <tr key={i} className="bg-gray-50">
                                                              {person.investmentTypeName === "Premium Call Deposit" &&
                                                                  <>
                                                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 pl-6">{FormatMoney(person.minimumAmount)}</td>
                                                                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{FormatMoney(person.maximumAmount)}</td>
                                                                      {rateVale !== person.id ?
                                                                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.rate}</td> :
                                                                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900" value={person.id}>
                                                                              <input
                                                                                  type="text"
                                                                                  name='rate'
                                                                                  placeholder={person.rate}
                                                                                  onChange={(e) => handleRate(e.target.value)}
                                                                              />
                                                                          </td>
                                                                      }
                                                                      {rateVale !== person.id ?
                                                                          <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                              <button onClick={() => edit(person.id)}>
                                                                                  <PencilIcon className="w-4" />
                                                                              </button>
                                                                          </td> :
                                                                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                              <button
                                                                                  onClick={() => update(person.id)} >
                                                                                  <CheckIcon className='w-8' />
                                                                              </button>
                                                                          </td>
                                                                      }
                                                                  </>
                                                              }

                                                          </tr>
                                                      ))}
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                </>
                  }
               
                                
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        </Layout>

    </>);
}